export default __webpack_public_path__ + "static/media/upmenu-sm.9d510e7f.svg";